import { FC } from "react";

import LicenseeContainer from "@app/containers/licensee";

const AddLinceseePage: FC = () => <LicenseeContainer />;

export default AddLinceseePage;
